// OOO — LP Quiz Engine
// Handles multi-step quiz: progress bar, advance-on-answer,
// Back button, localStorage persistence, email gate, result CTA routing.
// IIFE so nothing leaks to global scope (except the guard on window).

if (!window.__oooQuizLoaded) {
  window.__oooQuizLoaded = true;

  (function () {
    var STORE_KEY = 'ooo_quiz_answers';
    var quiz      = document.getElementById('ooo-quiz');
    if (!quiz) return; // section not on this page

    var steps     = Array.from(quiz.querySelectorAll('.ooo-quiz-step'));
    var total     = steps.length;                    // 8
    var backBtn   = quiz.querySelector('.ooo-quiz-back');
    var buildList = quiz.querySelector('.ooo-quiz-build-list');
    var buildCta  = quiz.querySelector('.ooo-quiz-build-cta');

    // progress is shown on the question/capture steps (2..7); 6-step span
    var PROG_FIRST = 2, PROG_LAST = 7;
    var progSpan   = PROG_LAST - PROG_FIRST + 1; // 6

    var current = 1;
    var answers = loadAnswers();

    // ---- reduced-motion / automation shortcut ----
    var INSTANT = (
      typeof navigator.webdriver !== 'undefined' && navigator.webdriver ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );

    function loadAnswers() {
      try { return JSON.parse(localStorage.getItem(STORE_KEY)) || {}; }
      catch (e) { return {}; }
    }
    function persist() {
      try { localStorage.setItem(STORE_KEY, JSON.stringify(answers)); } catch (e) {}
    }

    function setProgress(stepEl, stepNum) {
      var fill = stepEl.querySelector('.ooo-quiz-progress__fill');
      if (!fill) return;
      var pct = 0;
      if (stepNum >= PROG_FIRST) {
        var done = Math.min(stepNum, PROG_LAST) - PROG_FIRST;
        pct = (done / progSpan) * 100;
      }
      fill.style.width = pct + '%';
    }

    function show(stepNum) {
      current = stepNum;
      steps.forEach(function (s) {
        var n = parseInt(s.dataset.step, 10);
        s.classList.toggle('is-active', n === stepNum);
      });
      var el = steps[stepNum - 1];
      setProgress(el, stepNum);
      // back visible on steps 2..7 (not intro, not final building)
      if (backBtn) backBtn.hidden = (stepNum <= 1 || stepNum >= total);
      window.scrollTo({ top: 0, behavior: 'auto' });
      if (stepNum === total) runBuilding();
    }

    function next() {
      if (current < total) show(current + 1);
    }

    // ---- option selection (radio behaviour per step) ----
    steps.forEach(function (step) {
      var opts = step.querySelectorAll('.ooo-quiz-opt');
      var cont = step.querySelector('.ooo-quiz-continue');
      var qkey = step.dataset.q;

      // pre-fill stored selection on Back
      if (qkey && answers[qkey]) {
        opts.forEach(function (o) {
          if (o.dataset.value === answers[qkey]) {
            o.classList.add('is-selected');
          }
        });
        if (cont && opts.length) cont.disabled = false;
      }

      opts.forEach(function (opt) {
        opt.addEventListener('click', function () {
          opts.forEach(function (o) { o.classList.remove('is-selected'); });
          opt.classList.add('is-selected');
          answers[qkey] = opt.dataset.value;
          persist();
          if (cont) cont.disabled = false;
        });
      });
    });

    // ---- "next" triggers: start button, continue buttons, capture form ----
    quiz.querySelectorAll('[data-ooo-next]').forEach(function (trigger) {
      if (trigger.tagName === 'FORM') {
        trigger.addEventListener('submit', function (e) {
          e.preventDefault();
          var fn = trigger.querySelector('[name="ooo_firstName"]');
          var em = trigger.querySelector('[name="ooo_email"]');
          if (!fn || !em) { next(); return; }
          if (!fn.value.trim() || !em.checkValidity()) {
            trigger.classList.add('capture--err');
            (!fn.value.trim() ? fn : em).focus();
            return;
          }
          answers.firstName = fn.value.trim();
          answers.email     = em.value.trim();
          persist();
          next();
        });
      } else {
        trigger.addEventListener('click', function () {
          if (trigger.disabled) return;
          next();
        });
      }
    });

    // ---- back ----
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        if (current > 1) show(current - 1);
      });
    }

    // ---- final "building" animation ----
    var builtAlready = false;
    function runBuilding() {
      if (!buildList) return;
      var items = Array.from(buildList.querySelectorAll('li'));
      if (INSTANT) {
        items.forEach(function (li) { li.classList.add('is-done'); });
        if (buildCta) buildCta.classList.add('is-ready');
        return;
      }
      if (builtAlready) {
        items.forEach(function (li) { li.classList.add('is-done'); });
        if (buildCta) buildCta.classList.add('is-ready');
        return;
      }
      builtAlready = true;
      items.forEach(function (li, i) {
        setTimeout(function () { li.classList.add('is-done'); }, 500 + i * 650);
      });
      setTimeout(function () {
        if (buildCta) buildCta.classList.add('is-ready');
      }, 500 + items.length * 650 + 200);
    }

    // init
    show(1);
  })();
}
